export default {
  setWorkListsIds(state, ids) {
    state.workListsIds = ids;
  },
  setCurrentWorkList(state, order) {
    state.currentWorkList = order;
  },
  addPillsToWorkList(state, pills) {
    pills.forEach((p) => state.currentWorkList.worklistItems.push(p));
  },
  increaseAmountOfCanistersByPillId(state, pillId) {
    state.currentWorkList.worklistItems = state.currentWorkList.worklistItems.map((o) => {
      if (o.id === pillId) {
        if (isNaN(o.amountOfCanisters)) {
          o.amountOfCanisters = 1;
        } else {
          o.amountOfCanisters += 1;
        }
      }
      return o;
    });
  },
  decreaseAmountOfCanistersByPillId(state, pillId) {
    state.currentWorkList.worklistItems = state.currentWorkList.worklistItems.map((o) => {
      if (o.id === pillId) {
        if (isNaN(o.amountOfCanisters)) {
          o.amountOfCanisters = 0;
        } else {
          o.amountOfCanisters -= 1;
        }
      }
      return o;
    });
  },
  setAmountOfCanistersByPillId(state, { pillId, value }) {
    state.currentWorkList.worklistItems = state.currentWorkList.worklistItems.map((o) => {
      if (o.id === pillId) {
        o.amountOfCanisters = value;
      }
      return o;
    });
  },

  setCanisterAmountForOrder(state, value) {
    if (state.currentWorkList) {
      state.currentWorkList.canisterAmountForOrder = value;
    }
  },

  setPillAmountForCheckData(state, value) {
    if (state.currentWorkList) {
      state.currentWorkList.pillAmountForCheckData = value;
    }
  },
};
